import { createContext, useContext } from "react";

/** Shared context for the Enterprise mini-site. Carries the loaded
 * `/api/public/rentals/:slug` payload so child pages don't refetch. */
export const MiniSiteContext = createContext(null);

export function useMiniSite() {
  const v = useContext(MiniSiteContext);
  if (!v) throw new Error("useMiniSite must be used inside <MiniSiteProvider>");
  return v;
}

export const MINI_SITE_NAV = [
  { to: "home",     label: "Home" },
  { to: "fleet",    label: "Fleet" },
  { to: "booking",  label: "Booking" },
  { to: "about",    label: "About" },
  { to: "policies", label: "Policies" },
  { to: "faq",      label: "FAQ" },
  { to: "reviews",  label: "Reviews" },
  { to: "contact",  label: "Contact" },
];
